module.exports = __webpack_public_path__ + "static/media/art41.b47b4141.jpg";